import { ChangeDetectionStrategy, Component, HostListener, Input } from '@angular/core';

@Component({
    selector: 'app-standard-toolbar',
    templateUrl: './standard-toolbar.component.html',
    styleUrls: ['./standard-toolbar.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class StandardToolbarComponent {
    public isExpanded = false;
    public displayToggle = false;

    @Input() public set isWidthOfToolbarChanged(value: boolean) {
        this.displayToggle = value;
        this.isExpanded = false;
    }

    public toggle() {
        this.isExpanded = !this.isExpanded;
    }

    @HostListener('click', ['$event.target'])
    public afterMenuItemsClicked(element: EventTarget) {
        const htmlElement = element as HTMLElement;
        const isToolbarItem = htmlElement.parentElement?.classList.contains('menu-item');
        if (isToolbarItem) {
            this.isExpanded = false;
        }
    }

    @HostListener('document:click', ['$event.target'])
    public clickedOut(element: EventTarget) {
        const htmlElement = element as HTMLElement;
        const isNavbarElement = htmlElement.classList?.contains('navbar') || htmlElement.classList?.contains('fa-ellipsis-h');
        if (!isNavbarElement) {
            this.isExpanded = false;
        }
    }
}
